import { render, staticRenderFns } from "./TableReservations.vue?vue&type=template&id=26b3cf68&scoped=true&"
import script from "./TableReservations.vue?vue&type=script&lang=js&"
export * from "./TableReservations.vue?vue&type=script&lang=js&"
import style0 from "./TableReservations.vue?vue&type=style&index=0&id=26b3cf68&scoped=true&lang=css&"
import style1 from "./TableReservations.vue?vue&type=style&index=1&id=26b3cf68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3cf68",
  null
  
)

export default component.exports